import React from 'react';
import { Text, View } from '@react-pdf/renderer';

const DataOneLinerPrintSummary = ({
  label,
  value,
  primaryBrand,
}): JSX. Element => {
  return (
    <View>
      <Text style={{
        fontFamily: 'Courier-Bold',
        fontSize: 8,
        color: primaryBrand.colors.dark,
      }}>{label}<Text style={{
        fontFamily: 'Courier',
      }}> · {value}</Text></Text>
    </View>
  );
};

export default DataOneLinerPrintSummary;
